var cascaderData = {
  name: 'cascader',
  data: [{
    // c7n 但列表模式
    tabBorderColor: '#D9D9D9',
    tabActiveBorderColor: '#4F7DE7',
    tabHeight: 24,
    tabType: 'tab',
    // tab | block
    // 普通类型
    rightItemHeight: '',
    // auto | ''
    noShadow: false,
    columnGap: 0,
    columnBorder: '',
    columnShadow: '',
    itemHeight: 28,
    singleMenuItemCurrentBg: '',
    singleMenuItemCurrentColor: ''
  }]
};
export default cascaderData;